<template>
  <tourism-form>
    <ButtonCreate class="mt_m"/>
  </tourism-form>
</template>

<script>
import TourismForm from '@/components/Tourism/Form'
import ButtonCreate from '@/components/Tourism/ButtonCreate'

export default {
  components: {
    TourismForm,
    ButtonCreate
  },
  created: async function () {
    this.$store.dispatch('tourism/resetForm')
  }
}
</script>
